// export const API_URL = process.env.REACT_APP_BACKEND_API_URL;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
// Google Maps vector map style id. Falls back to the shared style used across
// the app when REACT_APP_MAP_ID isn't set for the environment.
export const MAP_ID = process.env.REACT_APP_MAP_ID || "6da3d397758f8b1a";
// export const REACT_APP_DEEP_LINK_URL = process.env.REACT_APP_DEEP_LINK_URL;
